export enum EquipmentListItemId {
  SettingMaintenance = 'settingWhenMaintenance',
  EditEquipmentName = 'editEquipmentName',
  ManagementZones = 'navigationToZoneList',
  OperationOutdoorUnit = 'outdoorUnitOperation',
  AdvancedSettingOperateEquipment = 'advancedSettings',
  SettingWhenLocal = 'settingWhenLocal',
  R32RefrigerantLeakAlarmStop = 'r32RefrigerantLeakAlarmStop',
}
